import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Procedure from './Procedure';
import $ from 'jquery';
import Patient from './Patients';
import Billing from './Billing';
import ErrorBoundary from '../../ErrorBoundary';
import MyJeevaAppUsage from './MyJeevaAppUsage';

class ViewForPhysicianTabSettings extends Component {
    constructor() {
        super();
        this.state = {
            showHomeEnityName: localStorage.getItem("homeEntityName")
        }
    }

    componentDidMount() {
        console.log("ViewForPhysicianTab Mounted!");
        if (!this.tabClickHandlerDefined) {
            this.tabClickHandlerDefined = true;
            $("#procedure, #patient, #billing, #patientAppUsage")
                .on("click", function () {
                    $("#procedure, #patient, #billing, #patientAppUsage")
                        .removeClass('active');
                    localStorage.setItem("admin-nav-bar-selection", $(this)[0].id);
                    $(this).addClass('active')
                });
        }
        this.markActiveTab();
    }

    paintTabs() {
        var currentPath = window.location.href;
        if (currentPath.includes('/projectmgmt/billing') ||
            currentPath.includes('/projectmgmt/billing/')) {
            return "billing";
        } else if (currentPath.includes('/projectmgmt/patient') ||
            currentPath.includes('/projectmgmt/patient/')) {
            return "patient";
        } else if (currentPath.includes('/projectmgmt/myjeeva-patient-app-usage') ||
            currentPath.includes('/projectmgmt/myjeeva-patient-app-usage/')) {
            return "patientAppUsage";
        }
        else {
            return "procedure";
        }
    }

    markActiveTab() {
        $("#procedure, #patient, #billing, #patientAppUsage").removeClass('active');
        var defaultSelection = false;
        var savedNavBarSelection = localStorage.getItem("admin-nav-bar-selection");
        var currentPath = window.location.href;
        var path = window.origin + "/my-jeeva/projectmgmt";
        var path1 = window.origin + "/my-jeeva/projectmgmt/";
        if (currentPath.includes('/projectmgmt/billing') ||
            currentPath.includes('/projectmgmt/billing/')) {
            defaultSelection = "billing";
        } else if (currentPath.includes('/projectmgmt/patient') ||
            currentPath.includes('/projectmgmt/patient/')) {
            defaultSelection = "patient";
        } else if (currentPath.includes('/projectmgmt/myjeeva-patient-app-usage') ||
            currentPath.includes('/projectmgmt/myjeeva-patient-app-usage/')) {
            defaultSelection = "patientAppUsage";
        }
        else if (currentPath == path || currentPath == path1) {
            defaultSelection = "procedure";
        }
        if (defaultSelection !== false) {
            $("#procedureNavMenu #" + defaultSelection).addClass('active');
            localStorage.setItem("admin-nav-bar-selection", defaultSelection);
        } else {
            if (savedNavBarSelection) {
                $("#procedureNavMenu #" + savedNavBarSelection).addClass('active');
            }

        }
    }


    render() {
        let activeTab = this.paintTabs();

        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        <title> Dheeyantra | Clusters Details</title>
                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4" >
                                        <h1 className="m-0 page-title">Engagements</h1>
                                    </div>
                                    <div className="col-sm-8" style={{ textAlign: 'right' }}>
                                        <h1 className="m-0 page-title" style={{ textAlign: 'right' }}>{this.state.showHomeEnityName}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="container-fluid" >
                            {/* Nav tabs */}
                            <div className="tab-class" style={{ marginLeft: '1vw' }}>

                                <ul className="nav nav-tabs border-bottom navCluster" id="procedureNavMenu">
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt" style={{
                                            textDecoration: 'none'
                                        }}>
                                        <li className={`nav-link ${activeTab == "procedure" ? "active" : ""}`} id="procedure" style={{ marginRight: '15px' }}>
                                            Treatment
                                        </li></Link>
                                    <Link className="nav-item" data-toggle="tab"
                                        to="/projectmgmt/myjeeva-patient-app-usage" style={{
                                            textDecoration: 'none'
                                        }}>
                                        <li className={`nav-link ${activeTab == "patientAppUsage" ? "active" : ""}`} id="patientAppUsage" style={{ marginRight: '15px' }}>
                                            MyJeeva Patient App Usage
                                        </li></Link>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/patient" component={Patient}></Route>
                        <Route path="/projectmgmt/billing" component={Billing}></Route>
                        <Route path="/projectmgmt/myjeeva-patient-app-usage" component={MyJeevaAppUsage}></Route>
                        <Route exact path="/projectmgmt" component={Procedure}></Route>
                        {/* Admin-only tabs (procedure, hospital, staff, ...) would otherwise render an empty page */}
                        <Redirect to="/projectmgmt" />
                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default ViewForPhysicianTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewForPhysicianTabSettings.js